export default class Dialog {
    constructor(appContext){
        this.appContext = appContext
    }

    display(data){
        return new Promise((resolve, reject) => {
            this.appContext.$eventBus.$emit("alert-on", {
                messageData: data,
                resolve: resolve
            });
        })
    }

    dismiss(){
        this.appContext.$eventBus.$emit('alert-off')
    }
}